import { render, staticRenderFns } from "./SHORT_ANSWER.vue?vue&type=template&id=7bfaed65&scoped=true&"
import script from "./SHORT_ANSWER.vue?vue&type=script&lang=js&"
export * from "./SHORT_ANSWER.vue?vue&type=script&lang=js&"
import style0 from "./SHORT_ANSWER.vue?vue&type=style&index=0&id=7bfaed65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfaed65",
  null
  
)

export default component.exports